export const changeBrowserEnLocale = {
  'change-browser.title': 'Open in Your Browser',
  'change-browser.description':
    'For the best experience, please open this page in your default web browser (Safari, Chrome, etc.)',
  'change-browser.how-to-open-in-browser': 'How to open in browser:',
  'change-browser.tap': 'Tap the',
  'change-browser.step-1': 'menu icon at the top right of your screen',
  'change-browser.step-2': 'Scroll through the options and tap',
  'change-browser.open-in-external-browser': '"Open in external browser"',
  'change-browser.open-in-chrome': '"Open in Chrome"',
  'change-browser.why': 'Why this matters:',
  'change-browser.why-description':
    'Opening in your default browser provides a better experience with full functionality and features.',
} as const;

export const changeBrowserEsLocale = {
  'change-browser.title': 'Abrir en tu navegador',
  'change-browser.description':
    'Para la mejor experiencia, por favor abre esta página en tu navegador predeterminado (Safari, Chrome, etc.)',
  'change-browser.how-to-open-in-browser': 'Cómo abrir en el navegador:',
  'change-browser.tap': 'Toca el',
  'change-browser.step-1':
    'icono de menú en la parte superior derecha de tu pantalla',
  'change-browser.step-2': 'Desplázate por las opciones y toca',
  'change-browser.open-in-external-browser': '"Abrir en navegador externo" ',
  'change-browser.open-in-chrome': '"Abrir en Chrome"',
  'change-browser.why': 'Porqué esto importa:',
  'change-browser.why-description':
    'Abrir en tu navegador predeterminado proporciona una mejor experiencia con funcionalidad y características completas.',
} as const;
